module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-toolbar', {
    staticStyle: {
      "background-color": "#5390cc"
    },
    attrs: {
      "dark": "",
      "fixed": ""
    }
  }, [(this.$router.currentRoute.name != 'Home') ? _c('router-link', {
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "0px"
    },
    attrs: {
      "to": "/",
      "tag": "span"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "45px",
      "color": "white",
      "margin-right": "-10px"
    }
  }, [_vm._v("keyboard_arrow_left")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": "/static/doc-images/lists/cropped-circle.png"
    }
  })]), _vm._v(" "), _c('v-toolbar-title', [_c('router-link', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "to": "/",
      "tag": "span"
    }
  }, [_vm._v("Avatar Meher Baba")]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "0.45em"
    },
    attrs: {
      "to": "/",
      "tag": "span"
    }
  }, [_vm._v("Avatar Meher Baba Perpetual Public Charitable Trust")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (this.$router.currentRoute.name == 'Home') ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right !important"
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("share")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Share With")]), _vm._v(" "), _c('v-card-text', [_c('social-sharing', {
    attrs: {
      "url": "https://ambshare.page.link/Zi7X",
      "title": "Avatar Meher Baba Perpetual Public Charitable Trust (AMBPPCT) Official Mobile App"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('v-layout', [_c('v-flex', {
            attrs: {
              "xs-4": ""
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('div', {
            staticStyle: {
              "text-align": "center",
              "padding-left": "5px"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/icons/Fb.png",
              "height": "35px",
              "width": "35px"
            }
          }), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Facebook")])])])], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs-4": ""
            }
          }, [_c('network', {
            attrs: {
              "network": "sms"
            }
          }, [_c('div', {
            staticStyle: {
              "text-align": "center",
              "padding-left": "5px"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/icons/message.png",
              "height": "35px",
              "width": "35px"
            }
          }), _c('br'), _vm._v(" "), _c('h5', [_vm._v("SMS")])])])], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs-4": ""
            }
          }, [_c('network', {
            attrs: {
              "network": "whatsapp"
            }
          }, [_c('div', {
            staticStyle: {
              "text-align": "center",
              "padding-left": "5px"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/icons/whatsapp.png",
              "height": "35px",
              "width": "35px"
            }
          }), _c('br'), _vm._v(" "), _c('h5', [_vm._v("WhatsApp")])])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', [_c('v-flex', {
            attrs: {
              "xs-4": ""
            }
          }, [_c('network', {
            attrs: {
              "network": "email"
            }
          }, [_c('div', {
            staticStyle: {
              "text-align": "center",
              "padding-left": "5px"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/icons/email.png",
              "height": "35px",
              "width": "35px"
            }
          }), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Email")])])])], 1)], 1)], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-xs-only"
  }, _vm._l((_vm.menuItems), function(item) {
    return _c('v-btn', {
      key: item.title,
      attrs: {
        "flat": "",
        "to": item.link
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "dark": ""
      }
    }, [_vm._v(_vm._s(item.icon))]), _vm._v("\n        " + _vm._s(item.title) + "\n      ")], 1)
  }))], 1), _vm._v(" "), (_vm.timeOut) ? _c('main', [_c('router-view')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c838855","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 307
// module chunks = 1